import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import type { State } from '@/reducers/types';

const trendsAdapter = createEntityAdapter<any>({
  sortComparer: (a, b) => a.id.localeCompare(b.id),
});

interface TrendsState {
  total: number;
  trendsData: any;
}

const initialState = trendsAdapter.getInitialState<TrendsState>({
  total: 0,
  trendsData: null,
});

const { name, reducer, actions } = createSlice({
  name: 'trends',
  initialState,
  reducers: {
    setTrendsData(state, action) {
      state.trendsData = action.payload;
    },
  },
});

const { setTrendsData } = actions;

export { name, reducer, setTrendsData };

export const selectTrendsData = (state: State) => state[name].trendsData;
